import * as moment from "moment";
import { IPrecatorioCalculator } from "../interfaces/calculator/IPrecatorioCalculator";

export const EmptyPrecatorioCalculatorRequest: IPrecatorioCalculator = {
  principal: 0,
  interest: 0,
  baseDate: moment(),
  issueDate: moment(),
  birthDate: moment(),
  credorBirthDate: undefined,
  correctionType: {
    id: null,
    name: undefined
  },
  court: {
    id: null,
    name: undefined
  },
  type: {
    id: null,
    name: undefined
  },
  processCode: undefined,
  processCodeSource: undefined,
  cpfCnpj: undefined
};


// WEBPACK FOOTER //
// ./src/services/mapper/EmptyPrecatorioCalculatorRequest.ts